import { AsiDialogView } from "@asi-ngtools/lib";
import { Component } from "@angular/core";
import * as moment from "moment";
import { NotificationModuleDto } from "@common/resources/resources";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'notification-module-component',
  templateUrl: './notification-module.component.html',
})
export class NotificationModuleComponent extends AsiDialogView {

  public notifications : NotificationModuleDto[]
  public index: number;
  public notification: NotificationModuleDto;

  constructor() {
    super();
  }

  GetSuivant(): void {
    this.index++;
    this.notification = this.notifications[this.index];
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/modal-notification-module/notification-module.component.ts